import React, { PureComponent } from "react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  // console.log("payloadpayloadpayload",label, payload)
  if (active) {
    return (
      <div className="custom-tooltip-partner">
        <p className="desc">Total Enrollments for {label} : {payload.length > 0 ? payload.map(iteam => iteam.value).reduce((a, b) => a + b, 0) : 0} </p>
      </div>
    );
  }
  return null;
};
export default class ParentPartnerDasboardContainerGraph extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      keysArray: [],
      dataForGraph: [],
      dataFor : this.props   //Newly added
    };
  }

  colors = [
    "#C0392B",
    "#E74C3C",
    "#9B59B6",
    "#2980B9",
    "#27AE60",
    "#F1C40F",
    "#E67E22",
    "#D35400",
    "#34495E",
  ];
  getTheKeys = (rawData) => {
    return this.props.rawData.map((obj) => obj.name);
  };

  

  getRandomColor = () => {
    const random = Math.floor(Math.random() * this.colors.length);
    return this.colors[random];
  };

  // componentDidMount() {                                          //Commented
  //   const keysArray = this.getTheKeys(this.props.rawData);
  //   const dataForGraph =
  //     this.props.rawData[0] &&
  //     this.props.rawData[0]["monthLabel"].map((month, index) => {
  //       let data = { Month: month };
  //       keysArray.forEach((key, i) => {
  //         data[key] =
  //           this.props.rawData[i] &&
  //          this.props.rawData[i].enrollments &&
  //          this.props.rawData[i].enrollments[index];
  //       });
  //       return data;
  //     });
  //   this.setState(
  //     {
  //       keysArray,
  //       dataForGraph,
  //     },
  //     () => {
  //       console.log(`dataForGraph`, this.state.dataForGraph);
  //       console.log(`keysArray`, this.state.keysArray);
  //     }
  //   );
  // }



  render() {
    let keysArray;                                                   //Added
    let dataForGraph;
    if(this.state.dataFor){
      keysArray = this.getTheKeys(this.props.rawData);
       dataForGraph =
      this.props.rawData[0] &&
      this.props.rawData[0]["monthLabel"].map((month, index) => {
        let data = { Month: month };
        keysArray.forEach((key, i) => {
          data[key] =
            this.props.rawData[i] &&
           this.props.rawData[i].enrollments &&
           this.props.rawData[i].enrollments[index];
        });
        return data;
      });
      console.log("render",keysArray,dataForGraph,this.props.rawData,this.props.rawData.map(x=>x["enrollments"]===undefined))
    }                                                               //Till here
    return (
      
      <LineChart
        width={700}
        height={200}
        data={dataForGraph}                                        //data={this.state.datForGraph}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid vertical={false} />
        <XAxis dataKey="Month" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend iconType="square" />
        {keysArray.map((item) => {                                //{this.state.keysArray.map()}
          return (
            <Line
            //   type="monotone"
              dataKey={item}
              stroke={this.getRandomColor()}
              dot = {false}
              
            />
          );
        })}
      </LineChart>
    );
  }
}

